export default __webpack_public_path__ + "static/media/noun-transaction-2183618.3de52766.svg";